import React from "react";

const BulletSVG = () => {
  const styleSVG = {
    position: "absolute",
    left: "-2.55rem",
    top: "0.5rem",
    background: "transparent",
    zIndex: "2",
  };

  return (
    <svg
      style={styleSVG}
      className="about__bullet"
      xmins="http://www.w3.org/2000/svg"
      fill="none"
      height="22"
      width="28"
    >
      <path
        d="m2.5 10a1 1 0 1 0 0 2zm23 2a1 1 0 1 0 0-2zm-23 0h23v-2h-23z"
        fill="#465061"
      ></path>
      <circle
        cx="14"
        cy="11"
        fill="#041027"
        r="5"
        stroke="#465062"
        strokeWidth="2"
      ></circle>
    </svg>
  );
};

export default BulletSVG;
